import React, { createContext, useContext, useEffect, useState } from "react";
import { translations, SUPPORTED_LANGUAGES } from "./translations";

const LanguageContext = createContext(null);

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState(() => {
    if (typeof window === "undefined") return "de";
    const stored = window.localStorage.getItem("sf_lang");
    if (stored && translations[stored]) return stored;
    return "de";
  });

  useEffect(() => {
    if (typeof window !== "undefined") {
      window.localStorage.setItem("sf_lang", lang);
      document.documentElement.lang = lang;
    }
  }, [lang]);

  const t = translations[lang] || translations.de;

  const value = { lang, setLang, t, languages: SUPPORTED_LANGUAGES };
  return <LanguageContext.Provider value={value}>{children}</LanguageContext.Provider>;
};

export const useT = () => {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error("useT must be used within LanguageProvider");
  return ctx;
};
